export const escapeRegExp = (str = '') => {
  if (typeof str !== 'string') {
    return '';
  }

  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
};
